var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/swagger-client/~/lodash/_Uint8Array.js
// module id = 468
// module chunks = 0